// User-facing sentences for the Connected apps tab. One sentence per
// failed-check state, shared by the in-page note and the refresh toast so the
// two can never disagree.
import { formatDate } from '../../../lib/formatDate';

export const REFRESH_ERRORS = {
  google_unreachable: "Couldn't reach Google. Try again later.",
  access_denied: "Couldn't reach Google. Try again later.",
  not_configured: "Google Workspace isn't connected to Nexus yet.",
  rate_limited: 'Too many refreshes. Wait a minute.',
};

export const disconnectErrors = (name) => ({
  google_unreachable: `Couldn't reach Google. ${name} is still connected. Try again later.`,
  access_denied: `Couldn't reach Google. ${name} is still connected. Try again later.`,
  not_configured: "Google Workspace isn't connected to Nexus yet.",
  rate_limited: 'Too many attempts. Wait a minute.',
});

// Null when the last check was clean.
export function stateSentence(sync, isMemberView) {
  if (!sync || !sync.last_error) return null;
  const attempt = formatDate(sync.last_attempt_at);
  if (!sync.last_success_at) {
    if (sync.last_error === 'google_user_not_found') return "This Google account no longer exists, so Google can't list its apps.";
    if (sync.last_error === 'access_denied' && isMemberView) {
      return `Google refused the request on ${attempt}. Check the Workspace domain-wide delegation settings.`;
    }
    return `Couldn't reach Google on ${attempt}. Nothing has been checked yet.`;
  }
  if (sync.last_error === 'google_user_not_found') {
    return `This Google account no longer exists. The list is from ${formatDate(sync.last_success_at)}.`;
  }
  return `Couldn't reach Google on ${attempt}. Showing the list from ${formatDate(sync.last_success_at)}.`;
}
